<template>
    <div class="form-item__container">
        <input
            :class="{ '-has-append': appendText }"
            v-model="model"
            class="form-item__field text-input"
            v-bind="inputProps"
        />
        <span class="text-input__append-text" v-if="appendText">{{ appendText }}</span>
    </div>
</template>

<script>
import { proxyModelMixin } from '@/mixins/proxyModelMixin';

export default {
    name: 'input-text',
    props: {
        modelValue: { type: [String, Number], default: '' },
        name: { type: String, default: '' },
        group: { type: String, default: null },
        type: { type: String, default: 'text' },
        placeholder: { type: String, default: '' },
        appendText: { type: String, default: '' },
    },
    mixins: [proxyModelMixin],
    computed: {
        inputProps() {
            return {
                name: this.name,
                placeholder: this.placeholder,
                type: this.type,
            };
        },
    },
    watch: {
        modelValue: function (newValue) {
            this.$emit('update-field', {
                name: this.name,
                group: this.group,
                value: newValue,
            });
        },
    },
};
</script>

<style lang="scss">
.text-input {
    &.-has-append {
        padding-right: 230px;
    }
    &__append-text {
        position: absolute;
        line-height: 16px;
        color: #787878;
        top: 42px;
        right: 18px;
        max-width: 200px;
        text-align: left;
        overflow: scroll;
        scrollbar-width: none;
        &::-webkit-scrollbar {
            display: none;
        }
    }
}
</style>
